var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"has-background":true,"contained":true}},[_c('div',[_c('OrderTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }